let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i7D3Z"), load("f7f51")]).then(() => parcelRequire('5dDzc'));